























import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockButtons from '@/components/BlockButtons.vue'

@Component
class SectionCallToAction extends mixins(SectionCore) {
  @Prop() readonly title: String = null
  @Prop() readonly buttons: ReadonlyArray<any> = []
  @Prop() readonly image: ReadonlyArray<any> = []
}

export default defineComponent({
  name: 'SectionCallToAction',
  components: {
    BlockButtons,
    SectionBasic,
  },
  props: SectionCallToAction.options.props,
})
